<template>
  <div class="container">
    <img src="../../assets/Escape/office.png" class="image" />
    <img src="../../assets/Escape/box2.png" id="box" class="elements" />
    <img
      src="../../assets/Escape/cryptex.png"
      id="cryptex"
      class="elements"
      @click="toggleCode"
      v-if="!cryptexOpened"
    />
    <img
      src="../../assets/Escape/cryptex_open.png"
      id="cryptex-open"
      class="elements"
      @click="toggleParchment"
      v-if="cryptexOpened"
    />
    <img
      src="../../assets/Escape/space.png"
      id="space-map"
      class="elements"
      @click="toggleOfficeSky"
    />

    <transition name="fade">
      <OfficeSky
        v-dragscroll
        v-if="displayOfficeSky"
        class="modale-map"
        @close="displayOfficeSky = false"
      />
    </transition>
    <transition name="fade">
      <Parchment
        v-dragscroll
        v-if="displayParchment"
        :inputList="inputList"
        class="parchment-modale"
        @close="displayParchment = false"
        @next="toggleFinalCode()"
      />
    </transition>
    <transition name="fade">
      <OfficeIntro
        v-dragscroll
        v-if="displayIntro"
        :inputList="inputList"
        class="modale"
        @close="displayIntro = false"
      />
    </transition>
    <transition name="fade">
      <Code
        v-if="displayCode && !cryptexOpen"
        class="modale"
        @close="displayCode = false"
        :title="'Entrer le code dans le cryptex :'"
        :password="'ALCHIMIE'"
        :length="8"
        @next="openCryptex()"
      />
    </transition>
    <transition name="fade">
      <Final
        v-if="displayFinalCode"
        class="final"
        @close="displayFinalCode = false"
        :startTime="startTime"
        :user="user"
        :hints="hints"
      />
    </transition>
  </div>
</template>

<script>
import Code from "./Code.vue";
import OfficeIntro from "./OfficeIntro.vue";
import OfficeSky from "./OfficeSky.vue";
import Parchment from "./Parchment.vue";
import Final from "./Final.vue";

export default {
  name: "LivingRoom",
  components: {
    OfficeIntro,
    OfficeSky,
    Code,
    Parchment,
    Final,
  },
  props: ["cryptexOpened", "inputList", "startTime", "user", "hints"],
  data() {
    return {
      displayIntro: true,
      displayCode: false,
      displayFinalCode: false,
      displayOfficeSky: false,
      displayParchment: false,
    };
  },
  methods: {
    toggleCode() {
      this.displayCode = true;
      this.displayIntro = false;
      this.displayFinalCode = false;
      this.displayOfficeSky = false;
    },
    toggleOfficeSky() {
      this.displayCode = false;
      this.displayIntro = false;
      this.displayFinalCode = false;
      this.displayOfficeSky = true;
    },
    openCryptex() {
      this.displayCode = false;
      this.displayIntro = false;
      this.displayOfficeSky = false;
      this.cryptexOpened = true;
      this.displayFinalCode = false;
      this.$emit("update", true);
    },
    toggleParchment() {
      this.displayCode = false;
      this.displayIntro = false;
      this.displayOfficeSky = false;
      this.displayFinalCode = false;
      this.displayParchment = true;
    },
    toggleFinalCode() {
      this.displayCode = false;
      this.displayIntro = false;
      this.displayOfficeSky = false;
      this.displayParchment = false;
      this.displayFinalCode = true;
    },
  },
};
</script>

<style scoped>
.container {
  height: 100%;
  width: 100%;
  position: relative;
}
.image {
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  cursor: zoom-in;
}
#box {
  position: absolute;
  bottom: 6%;
  right: 25%;
  height: 18%;
}
#cryptex {
  position: absolute;
  bottom: 35.8%;
  left: 32%;
  height: 5%;
  transform: rotate(1deg);
}
#cryptex-open {
  position: absolute;
  bottom: 35.8%;
  left: 32%;
  height: 5%;
}
#envelope {
  position: absolute;
  bottom: 8%;
  right: 40%;
  height: 9%;
}
#space-map {
  position: absolute;
  bottom: 35.8%;
  right: 48%;
  height: 9%;
}
.elements:hover {
  opacity: 0.8;
  cursor: zoom-in;
}
#box:hover {
  cursor: not-allowed;
}
.modale {
  position: absolute;
  top: 10%;
  height: auto;
  max-height: 75%;
  right: 25%;
  width: 50%;
}
.final {
  position: absolute;
  top: 5vh;
  left: 5vw;
  height: 90vh;
  width: 90vw;
}
.parchment-modale {
  position: absolute;
  top: 10%;
  height: auto;
  max-height: 75%;
  right: 5%;
  width: 85%;
}
.modale-map {
  position: absolute;
  top: 10%;
  height: 80vh;
  max-height: 90%;
  width: 60%;
  left: 18%;
}
</style>
